(function () {
  if (window._offerCarouselAutoscrollLoaded) return;
  window._offerCarouselAutoscrollLoaded = true;

  const initialized = new WeakSet();
  const DELAY = 4000;

  function initAutoFade(container) {
    if (initialized.has(container)) return;

    const carousel = container.querySelector('scroll-carousel');
    if (!carousel) return;

    const items = Array.from(carousel.children).filter(el => el.classList.contains('offer-item'));
    if (items.length <= 1) return;

    initialized.add(container);

    let current = 0;
    items[0].classList.add('is-active');

    let paused = false;
    container.addEventListener('mouseenter', () => { paused = true; });
    container.addEventListener('mouseleave', () => { paused = false; });
    container.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    container.addEventListener('touchend', () => setTimeout(() => { paused = false; }, 2000));

    const nav = container.querySelector('carousel-navigation');

    setInterval(() => {
      if (paused || document.hidden || !container.isConnected) return;

      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');

      if (nav) {
        nav.querySelectorAll('.scroll-marker').forEach((dot, i) => {
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }
    }, DELAY);
  }

  function scan() {
    document.querySelectorAll('.offer-carousel[data-autofade]').forEach(initAutoFade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
